import { EmptyNote, Skeleton } from "./ui";

// Labelled horizontal bars, longest first; value text is always shown, so
// the bar is never the only carrier of the number.
export default function BarList({ items, loading, label }) {
  if (loading) {
    return (
      <div className="flex flex-col gap-4">
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-8 w-full" />
        ))}
      </div>
    );
  }
  if (!items?.length) return <EmptyNote />;

  const max = Math.max(...items.map((i) => i.value || 0)) || 1;
  return (
    <ul aria-label={label} className="flex flex-col gap-3.5">
      {items.map((item) => (
        <li key={item.key} className="flex flex-col gap-1.5">
          <div className="flex justify-between gap-2 text-sm">
            <span className="min-w-0 truncate text-gray-700">{item.name}</span>
            <span className="font-semibold text-gray-900">{item.display}</span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-gray-100" aria-hidden="true">
            <div
              className="h-full rounded-full bg-indigo-600"
              style={{ width: `${((item.value || 0) / max) * 100}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
